import { render, staticRenderFns } from "./ForgotPasswordModal.vue?vue&type=template&id=7d04bcdc"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordModal.vue?vue&type=style&index=0&id=7d04bcdc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports